import { useQuery } from '@tanstack/react-query';

import { instagramQueries } from './queries';

export function useGetInstagramAccount(pharmacyId: string | undefined) {
  const { data: account, isPending } = useQuery(
    instagramQueries.account(pharmacyId)
  );

  return { account, isPending };
}
